import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { IWithCredentialsConfig, WITH_CREDENTIALS_CONFIG } from './providers/with-credentials-config.provider';

@Injectable()
export class WithCredentialsInterceptor implements HttpInterceptor {
  private readonly configOrigins: string[];

  constructor(@Inject(WITH_CREDENTIALS_CONFIG) private readonly config: IWithCredentialsConfig) {
    // Remove any paths from urls
    this.configOrigins = this.config.origins.map((o) => new URL(o).origin);
  }

  intercept(request: HttpRequest<any>, next: HttpHandler) {
    const origin = new URL(request.url).origin;
    if (this.configOrigins.includes(origin)) {
      request = request.clone({
        withCredentials: true,
      });
    }

    return next.handle(request);
  }
}
